import sizeCharts from "./sizeCharts";
import measures from "./measures";
import fits from "./fits";
import labelingStandards from "./labelingStandards";
import client from "./client";
import visitor from "./visitor";
import user from "./user";
import accessToken from "./accessToken";

export default {
  ...accessToken,
  ...sizeCharts,
  ...measures,
  ...fits,
  ...labelingStandards,
  ...client,
  ...visitor,
  ...user
};
